<script>
  import Box from "$lib/components/lines/Box.svelte";
</script>

<Box l t b class="h-fit flex flex-row gap-4 p-4 text-zinc-7" opacity="0.05">
  <slot />
</Box>
